import { Box } from '@chakra-ui/react';
import React from 'react';
import Layout from './components/layout';
import Providers from './components/providers';

function AnalyticsV3() {
  return (
    <Providers>
      <Box>
        <Layout />
      </Box>
    </Providers>
  );
}

export default AnalyticsV3;
